import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CellContext } from '@tanstack/react-table';
import { FormattedMessage, useIntl } from 'react-intl';

import { Button } from 'src/registry/ui/Button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/registry/ui/Tooltip';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import { SubscriptionItem } from 'src/features/subscriptionItems/utils/types';
import DeleteSubscriptionItemModal from 'src/features/subscriptionItems/components/forms/DeleteSubscriptionItemModal';
import { Link, useParams } from 'react-router-dom';
import UpdateSubscriptionItemFormModal from 'src/features/subscriptionItems/components/forms/UpdateSubscriptionItemFormModal';
import { subscriptionItemsMessages } from 'src/features/subscriptionItems/utils/messages';
import useHasPermissions from 'src/utils/useHasPermissions';
import { PERMISSION } from 'src/features/auth/types';

export default function CellSubscriptionItemActions({ row }: CellContext<SubscriptionItem, unknown>) {
    const { formatMessage } = useIntl();

    const { subscriptionId = '' } = useParams();
    const itemIsRequired = row.original.service_plan_item.is_required;
    const permissionManageSubscriptions = useHasPermissions([PERMISSION.MANAGE_SUBSCRIPTIONS]);

    return (
        <div className="flex w-full justify-end gap-1">
            <TooltipProvider>
                <Tooltip>
                    <TooltipTrigger asChild>
                        <Link to={`/subscriptions/${subscriptionId}/subscription-item/${row.original.id}`}>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.EXPAND} />
                            </Button>
                        </Link>
                    </TooltipTrigger>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.dashboard} />
                    </TooltipContent>
                </Tooltip>
                {permissionManageSubscriptions && !itemIsRequired && (
                    <>
                        <Tooltip>
                            <UpdateSubscriptionItemFormModal
                                semantics={{ entryName: formatMessage(subscriptionItemsMessages.item).toLowerCase() }}
                                selectedSubscriptionItem={row.original}
                            >
                                <TooltipTrigger asChild>
                                    <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                        <FontAwesomeIcon icon={ICON_MAP.EDIT} />
                                    </Button>
                                </TooltipTrigger>
                            </UpdateSubscriptionItemFormModal>
                            <TooltipContent>
                                <FormattedMessage {...generalMessages.edit} />
                            </TooltipContent>
                        </Tooltip>
                        <Tooltip>
                            <DeleteSubscriptionItemModal selectedSubscriptionItem={row.original}>
                                <TooltipTrigger asChild>
                                    <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                        <FontAwesomeIcon icon={ICON_MAP.DELETE} />
                                    </Button>
                                </TooltipTrigger>
                            </DeleteSubscriptionItemModal>
                            <TooltipContent>
                                <FormattedMessage {...generalMessages.delete} />
                            </TooltipContent>
                        </Tooltip>
                    </>
                )}
            </TooltipProvider>
        </div>
    );
}
